import { MODULE_FAMILIES } from "../../../../../../../components/Shared/Constants/Module";
import { CONSTANTS } from "../../../../../../../components/Shared/Constants/Constants";
import React from "react";

type MetadatasMetadataProps = {
	templateName: string;
	metadatas: {
		[key: string]: string;
	};
	show: boolean;
};

export default function MetadatasMetadataComponent(
	props: MetadatasMetadataProps
) {
	return (
		props.show && (
			<>
				{Array.from(
					{ length: props.templateName === MODULE_FAMILIES.LIBERO_G ? 8 : 7 },
					(_, i) =>
						i + (props.templateName === MODULE_FAMILIES.LIBERO_G ? 1 : 2)
				).map((num) => {
					const key = `metadata_${num}`;
					return (
						<tr key={key}>
							<td>Metadata {num}</td>
							<td>{props.metadatas[key] || CONSTANTS.NOT_AVAILABLE}</td>
						</tr>
					);
				})}
			</>
		)
	);
}
